import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="w-full py-4 px-6 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/bloodResults.png" alt="Blood Results Logo" className="h-8 w-auto" />
            <span className="text-lg font-semibold text-gray-900">Blood Results</span>
          </Link>
        </div>
      </header>

      {/* Brand Banner */}
      <div className="w-full py-6 bg-white flex justify-center border-t border-gray-200">
        <img
          src="/blood-results-brand.svg"
          alt="Blood Results Brand"
          className="h-20 w-auto"
        />
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Cookie Policy</h1>
          <p className="text-sm text-gray-500 mb-8">
            Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. What Are Cookies</h2>
              <p className="text-gray-700 leading-relaxed">
                Cookies are small text files that are placed on your computer or mobile device when you
                visit a website. They are widely used to make websites work more efficiently, provide
                information to the owners of the site, and improve the user experience.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Cookies</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                KNX Associates Ltd, trading as Blood Results, uses cookies to distinguish you from other users
                of our platform. This helps us to provide you with a good experience when you browse our
                website and also allows us to improve our site. We use the following categories of cookies:
              </p>

              <div className="space-y-4 ml-4">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">2.1 Strictly Necessary Cookies</h3>
                  <p className="text-gray-700 leading-relaxed">
                    These cookies are essential for the operation of our website. They include, for example,
                    cookies that enable you to log into secure areas of our website. Without these cookies,
                    services you have asked for cannot be provided.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">2.2 Analytical/Performance Cookies</h3>
                  <p className="text-gray-700 leading-relaxed">
                    These cookies allow us to recognize and count the number of visitors and to see how
                    visitors move around our website when they are using it. This helps us to improve the
                    way our website works, for example, by ensuring that users find what they are looking for easily.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">2.3 Functionality Cookies</h3>
                  <p className="text-gray-700 leading-relaxed">
                    These cookies are used to recognize you when you return to our website. This enables us
                    to personalize our content for you, greet you by name, and remember your preferences
                    (for example, your choice of language or region).
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">2.4 Session Cookies</h3>
                  <p className="text-gray-700 leading-relaxed">
                    These are temporary cookies that expire when you close your browser. They are used to
                    maintain your session state while you navigate through our platform.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Cookies We Use</h2>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cookie Name</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Purpose</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duration</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">sessionId</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Strictly Necessary</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Maintains user session and authentication state</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Session</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">authToken</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Strictly Necessary</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Authentication and security</td>
                      <td className="px-6 py-4 text-sm text-gray-700">24 hours</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">cookieConsent</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Strictly Necessary</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Stores your cookie consent preferences</td>
                      <td className="px-6 py-4 text-sm text-gray-700">1 year</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">userPreferences</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Functionality</td>
                      <td className="px-6 py-4 text-sm text-gray-700">Remembers your platform preferences and settings</td>
                      <td className="px-6 py-4 text-sm text-gray-700">1 year</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Your Cookie Choices</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                You have the right to decide whether to accept or reject cookies. You can exercise your
                cookie rights by setting your preferences in the Cookie Consent banner that appears when
                you first visit our website.
              </p>

              <div className="space-y-4 ml-4">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">4.1 Browser Controls</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    Most web browsers allow some control of most cookies through the browser settings. To find
                    out more about cookies, including how to see what cookies have been set and how to manage
                    and delete them, visit:
                  </p>
                  <ul className="list-disc ml-6 text-gray-700 space-y-1">
                    <li><a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.aboutcookies.org</a></li>
                    <li><a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.allaboutcookies.org</a></li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">4.2 Opting Out</h3>
                  <p className="text-gray-700 leading-relaxed">
                    You can opt out of cookies by activating the setting on your browser that allows you to
                    refuse the setting of all or some cookies. However, if you use your browser settings to
                    block all cookies (including essential cookies), you may not be able to access all or
                    parts of our website.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Third-Party Cookies</h2>
              <p className="text-gray-700 leading-relaxed">
                We do not currently use third-party cookies on our platform. If this changes in the future,
                we will update this policy and request your consent where required.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Local Storage</h2>
              <p className="text-gray-700 leading-relaxed mb-2">
                In addition to cookies, we may use local storage (HTML5) to store information on your
                device. Local storage is similar to cookies but can store larger amounts of data. We use
                local storage to:
              </p>
              <ul className="list-disc ml-6 text-gray-700 space-y-1">
                <li>Store your health data preferences and visualization settings</li>
                <li>Cache frequently accessed data for improved performance</li>
                <li>Maintain your session state across browser tabs</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Do Not Track Signals</h2>
              <p className="text-gray-700 leading-relaxed">
                Some browsers incorporate a "Do Not Track" (DNT) feature that signals to websites that
                you do not want to have your online activity tracked. Our website currently does not
                respond to DNT signals.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Updates to This Policy</h2>
              <p className="text-gray-700 leading-relaxed">
                We may update this Cookie Policy from time to time to reflect changes in our practices
                or for other operational, legal, or regulatory reasons. We will notify you of any material
                changes by posting the new Cookie Policy on this page.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed mb-2">
                If you have any questions about our use of cookies or this Cookie Policy, please contact us:
              </p>
              <ul className="space-y-1 text-gray-700">
                <li><strong>Company:</strong> KNX Associates Ltd</li>
                <li><strong>Trading as:</strong> Blood Results</li>
                <li><strong>Email:</strong> <a href="mailto:privacy@knx-associates.co.uk" className="text-blue-600 hover:underline">privacy@knx-associates.co.uk</a></li>
                <li><strong>Data Protection Officer:</strong> <a href="mailto:dpo@knx-associates.co.uk" className="text-blue-600 hover:underline">dpo@knx-associates.co.uk</a></li>
              </ul>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link to="/" className="text-blue-600 hover:text-blue-700">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="w-full py-6 px-6 bg-white border-t border-gray-200 mt-12">
        <div className="max-w-7xl mx-auto text-center text-sm text-gray-500">
          <p>&copy; 2025 Blood-Results.co.uk A KNX-Associates Ltd Brand. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default CookiePolicy;
